"use strict";
// These lint rules are temporarily disabled until our fully typescript support is added
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePlayer = void 0;
// @ts-ignore
var playkit_js_1 = require("@playkit-js/playkit-js");
var default_thumbnail_api_params_1 = require("./default-thumbnail-api-params");
var timer_1 = require("./timer");
var ImagePlayer = /** @class */ (function (_super) {
    __extends(ImagePlayer, _super);
    function ImagePlayer(source, config) {
        var _this = _super.call(this) || this;
        _this.eventManager = new playkit_js_1.EventManager();
        _this._playbackRate = 1;
        _this.timer = new timer_1.Timer();
        _this.isFirstPlay = true;
        _this.isLoadingStart = false;
        _this.isReloadedOnfullscreen = false;
        _this.createImageElement();
        _this.init(source, config);
        return _this;
    }
    ImagePlayer.prototype.init = function (source, config) {
        this.source = source;
        this.config = config;
        this.setDefaultConfig();
        this.concatenateThumbnailParams(source);
        this.attach();
    };
    ImagePlayer.prototype.setDefaultConfig = function () {
        this.config.playback.autoplay = true;
    };
    ImagePlayer.prototype.createImageElement = function () {
        this.el = document.createElement('img');
        this.el.id = playkit_js_1.Utils.Generator.uniqueId(5);
        this.el.alt = '';
    };
    ImagePlayer.prototype.load = function (startTime) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.isLoadingStart = true;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.el.onload = function () {
                            resolve({ tracks: [] });
                            _this.onImageLoaded();
                        };
                        _this.el.onerror = function (error) {
                            ImagePlayer._logger.error("The image failed to load, img url:".concat(_this.source.url), error);
                            reject(error);
                        };
                        // @ts-ignore
                        _this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.LOAD_START));
                        _this.el.src = _this.source.url;
                    })];
            });
        });
    };
    ImagePlayer.prototype.attach = function () {
        var _this = this;
        // @ts-ignore
        this.eventManager.listen(this.timer, playkit_js_1.EventType.ENDED, function (event) { return _this.dispatchEvent(event); });
        // @ts-ignore
        this.eventManager.listen(this.timer, playkit_js_1.EventType.TIME_UPDATE, function (event) { return _this.dispatchEvent(event); });
        this.eventManager.listen(document.getElementById(this.config.targetId), 'fullscreenchange', function (event) {
            _this.reloadHigherQualityOnFullscreen();
        });
    };
    ImagePlayer.prototype.play = function () {
        if (this.isTimedImage())
            this.timer.start(this.duration);
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.PLAYBACK_START));
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.PLAY));
        if (this.isFirstPlay) {
            // @ts-ignore
            this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.FIRST_PLAY));
            this.isFirstPlay = false;
        }
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.DURATION_CHANGE));
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.PLAYING));
        // @ts-ignore
        if (this.isFirstPlay)
            this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.FIRST_PLAYING));
        return Promise.resolve();
    };
    ImagePlayer.prototype.isTimedImage = function () {
        return this.config.sources.duration > 0;
    };
    ImagePlayer.prototype.onImageLoaded = function () {
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.LOADED_METADATA));
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.LOADED_DATA));
    };
    ImagePlayer.prototype.concatenateThumbnailParams = function (source) {
        var _a, _b;
        var thumbnailAPIParams = __assign(__assign(__assign({ width: this.getPlayerWidth() }, (this.shouldAddKs() && { ks: this.config.session.ks })), default_thumbnail_api_params_1.defaultThumbnailApiParams), (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.imageSourceOptions) === null || _b === void 0 ? void 0 : _b.thumbnailAPIParams);
        Object.keys(thumbnailAPIParams).forEach(function (parmaName) {
            source.url += "/".concat(parmaName, "/").concat(thumbnailAPIParams[parmaName]);
        });
    };
    ImagePlayer.prototype.shouldAddKs = function () {
        var _a;
        return typeof ((_a = this.config.session) === null || _a === void 0 ? void 0 : _a.isAnonymous) === 'boolean' && !this.config.session.isAnonymous;
    };
    ImagePlayer.prototype.getPlayerWidth = function () {
        return document.getElementById(this.config.targetId).offsetWidth;
    };
    ImagePlayer.prototype.reloadHigherQualityOnFullscreen = function () {
        if (document.fullscreenElement && !this.isReloadedOnfullscreen) {
            var currentWidth = this.getPlayerWidth();
            var fullscreenWidth = document.body.offsetWidth;
            if (currentWidth < fullscreenWidth) {
                this.source.url = this.source.url.replace(/\/width\/([0-9]+)\//, "/width/".concat(document.body.offsetWidth, "/"));
                this.load(0).then(function () {
                    ImagePlayer._logger.debug('Entering fullscreen mode - image reloaded');
                });
                this.isReloadedOnfullscreen = true;
            }
        }
    };
    ImagePlayer.isSupported = function () {
        return true;
    };
    ImagePlayer.createEngine = function (source, config) {
        return new this(source, config);
    };
    ImagePlayer.canPlaySource = function (source) {
        return true;
    };
    ImagePlayer.runCapabilities = function () {
        return;
    };
    ImagePlayer.getCapabilities = function () {
        var _a;
        var capabilities = (_a = {},
            _a[ImagePlayer.id] = {
                autoplay: true
            },
            _a);
        return Promise.resolve(capabilities);
    };
    ImagePlayer.prepareVideoElement = function () {
        ImagePlayer._logger.debug('Prepare the Image element');
    };
    ImagePlayer.prototype.attachMediaSource = function () { };
    ImagePlayer.prototype.detach = function () { };
    ImagePlayer.prototype.detachMediaSource = function () { };
    ImagePlayer.prototype.enableAdaptiveBitrate = function () { };
    ImagePlayer.prototype.enterPictureInPicture = function () { };
    ImagePlayer.prototype.exitPictureInPicture = function () { };
    ImagePlayer.prototype.getStartTimeOfDvrWindow = function () {
        return 0;
    };
    ImagePlayer.prototype.getVideoElement = function () {
        return this.el;
    };
    ImagePlayer.prototype.hideTextTrack = function () { };
    ImagePlayer.prototype.isAdaptiveBitrateEnabled = function () {
        return false;
    };
    ImagePlayer.prototype.isLive = function () {
        return false;
    };
    ImagePlayer.prototype.isPictureInPictureSupported = function () {
        return false;
    };
    ImagePlayer.prototype.pause = function () {
        this.timer.end();
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.PAUSE));
    };
    ImagePlayer.prototype.resetAllCues = function () { };
    ImagePlayer.prototype.restore = function (source, config) {
        this.reset();
        this.init(source, config);
    };
    ImagePlayer.prototype.seekToLiveEdge = function () { };
    ImagePlayer.prototype.selectAudioTrack = function (audioTrack) { };
    ImagePlayer.prototype.selectTextTrack = function (textTrack) { };
    ImagePlayer.prototype.selectVideoTrack = function (videoTrack) { };
    Object.defineProperty(ImagePlayer.prototype, "src", {
        get: function () {
            return this.isLoadingStart && this.source ? this.source.url : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePlayer.prototype, "id", {
        get: function () {
            return ImagePlayer.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePlayer.prototype, "playbackRates", {
        get: function () {
            return [0.5, 1, 1.5, 2];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePlayer.prototype, "playbackRate", {
        get: function () {
            return this._playbackRate;
        },
        set: function (playbackRate) {
            this._playbackRate = playbackRate;
            this.timer.speed(playbackRate);
            // @ts-ignore
            this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.RATE_CHANGE));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePlayer.prototype, "duration", {
        get: function () {
            return this.config.sources.duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePlayer.prototype, "currentTime", {
        get: function () {
            return this.timer.currentTime;
        },
        set: function (to) {
            this.timer.seek(to);
            // @ts-ignore
            this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.SEEKED));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImagePlayer.prototype, "buffered", {
        get: function () {
            return {
                start: function (index) {
                    return 0;
                },
                end: function (index) {
                    return 0;
                },
                length: 0
            };
        },
        enumerable: false,
        configurable: true
    });
    ImagePlayer.prototype.getThumbnail = function (time) {
        return null;
    };
    ImagePlayer.prototype.getDrmInfo = function () {
        return null;
    };
    ImagePlayer.prototype.reset = function () {
        this.eventManager.removeAll();
        this.isFirstPlay = true;
        this.isLoadingStart = false;
        this.isReloadedOnfullscreen = false;
        this.playbackRate = 1;
        this.timer.reset();
    };
    ImagePlayer.prototype.destroy = function () {
        this.reset();
        this.el.remove();
    };
    ImagePlayer._logger = (0, playkit_js_1.getLogger)('Image');
    ImagePlayer.id = 'image';
    return ImagePlayer;
}(playkit_js_1.FakeEventTarget));
exports.ImagePlayer = ImagePlayer;
